import React from 'react';
import {
	Backdrop,
	Wrapper,
	HeadingWrapper,
	Heading,
	CloseWraper,
} from './ToggleSidebar.styles';
import { ApButtonIcon } from '@alixpartners/ui-components';

const ToggleSidebar = ({
	toRight = true,
	heading,
	handleClose,
	show,
	children,
	width,
	showOverflow,
}) => {
	return (
		<Backdrop toggle={show}>
			<Wrapper toRight={toRight} width={width} showOverflow={showOverflow}>
				<HeadingWrapper>
					<Heading>{heading}</Heading>
					<CloseWraper>
						<ApButtonIcon
							title="Close"
							iconName="close"
							onClick={() => handleClose(false)}
						/>
					</CloseWraper>
				</HeadingWrapper>
				{children}
			</Wrapper>
		</Backdrop>
	);
};

export default ToggleSidebar;
